import { render, staticRenderFns } from "./QR.vue?vue&type=template&id=3a3b7ba5&scoped=true&"
import script from "./js/qr.js?vue&type=script&lang=js&"
export * from "./js/qr.js?vue&type=script&lang=js&"
import style0 from "./QR.vue?vue&type=style&index=0&id=3a3b7ba5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a3b7ba5",
  null
  
)

export default component.exports